import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { createStore, applyMiddleware  } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import rootReducers from '../reducers/rootReducers'

const loggerMiddleware = createLogger()
const composeEnhancers = composeWithDevTools({

})

const store = createStore(
	rootReducers,
	composeEnhancers(
		applyMiddleware(
			thunkMiddleware,
			// loggerMiddleware
		)
	)
)

export default store